import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import Panel from '@components/persistence-admin-panel';

const { Header, Content, Sider } = Layout;

function PersistenceAdmin() {
  const [selectedMenuItem, setSelectedMenuItem] = useState('report');
  const handleSelected = ({ key }) => setSelectedMenuItem(key);

  return (
    <Layout>
      <Header className="header">
        <h3 style={{ color: 'snow' }}>Persistence Admin Panel</h3>
      </Header>
      <Layout>
        <Sider width={200} className="site-layout-background">
          <Menu
            mode="inline"
            defaultSelectedKeys={[selectedMenuItem]}
            style={{ height: '100%', borderRight: 0 }}
            onSelect={handleSelected}
          >
            <Menu.Item key="report">Report</Menu.Item>
            <Menu.Item key="manage">Manage</Menu.Item>
          </Menu>
        </Sider>
        <Layout style={{ padding: '0 24px 24px' }}>
          <Content
            className="site-layout-background"
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
            }}
          >
            <Panel selectedMenuItem={selectedMenuItem} />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default PersistenceAdmin;
